import React from 'react'
import { Breadcrumb } from 'antd'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

import theme from '../styles/theme'
import { rem, media } from '../styles/tools'

import Head from '../components/Head'
import Container from '../components/Container'
import Link from '../components/Link'
import Space from '../components/Space'
import { Title, Paragraph } from '../styles/typography'

const Header = ({ title, isRoot, ...props }) => {
  const data = useStaticQuery(graphql`
    {
      avatar: file(relativePath: { eq: "saijo-george.png" }) {
        childImageSharp {
          fluid(maxWidth: 44, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <header
      css={{
        // position: 'sticky',
        // zIndex: 1,
        // top: 0,
        padding: `${rem(30)} 0`,
        borderTop: `8px solid ${theme.colors.blue}`,
      }}
      {...props}
    >
      <Container css={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: -5,
              // color: 'rgba(0, 0, 0, 0.85) !important',
            }}
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              css={{ marginRight: 8 }}
              aria-hidden
            >
              <path
                d="M8.66667 3.25C8.09203 3.25 7.54093 3.47827 7.1346 3.8846C6.72827 4.29093 6.5 4.84203 6.5 5.41667V9.75C6.5 10.3246 6.27173 10.8757 5.8654 11.2821C5.45907 11.6884 4.90797 11.9167 4.33333 11.9167H3.25V14.0833H4.33333C4.90797 14.0833 5.45907 14.3116 5.8654 14.7179C6.27173 15.1243 6.5 15.6754 6.5 16.25V20.5833C6.5 21.158 6.72827 21.7091 7.1346 22.1154C7.54093 22.5217 8.09203 22.75 8.66667 22.75H10.8333V20.5833H8.66667V15.1667C8.66667 14.592 8.43839 14.0409 8.03206 13.6346C7.62574 13.2283 7.07464 13 6.5 13C7.07464 13 7.62574 12.7717 8.03206 12.3654C8.43839 11.9591 8.66667 11.408 8.66667 10.8333V5.41667H10.8333V3.25H8.66667ZM17.3333 3.25C17.908 3.25 18.4591 3.47827 18.8654 3.8846C19.2717 4.29093 19.5 4.84203 19.5 5.41667V9.75C19.5 10.3246 19.7283 10.8757 20.1346 11.2821C20.5409 11.6884 21.092 11.9167 21.6667 11.9167H22.75V14.0833H21.6667C21.092 14.0833 20.5409 14.3116 20.1346 14.7179C19.7283 15.1243 19.5 15.6754 19.5 16.25V20.5833C19.5 21.158 19.2717 21.7091 18.8654 22.1154C18.4591 22.5217 17.908 22.75 17.3333 22.75H15.1667V20.5833H17.3333V15.1667C17.3333 14.592 17.5616 14.0409 17.9679 13.6346C18.3743 13.2283 18.9254 13 19.5 13C18.9254 13 18.3743 12.7717 17.9679 12.3654C17.5616 11.9591 17.3333 11.408 17.3333 10.8333V5.41667H15.1667V3.25H17.3333Z"
                fill="#1890FF"
              />
            </svg>
            <Title
              as="h1"
              css={{
                [media.max.mobileLg]: {
                  maxWidth: '15.5em',
                  fontSize: 16,
                  lineHeight: 1.3,
                },
              }}
            >
              {title}
            </Title>
          </div>
          <Space y={10} />
          <Breadcrumb separator="»">
            <Breadcrumb.Item>
              <Paragraph
                as="a"
                href="https://saijogeorge.com"
                css={{ '&:not(:hover)': { color: '#58696d !important' } }}
              >
                Saijo George
              </Paragraph>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Paragraph
                as="a"
                href="https://saijogeorge.com/projects.html"
                css={{ '&:not(:hover)': { color: '#58696d !important' } }}
              >
                Side Projects
              </Paragraph>
            </Breadcrumb.Item>
            {!isRoot && (
              <Breadcrumb.Item>
                <Paragraph
                  as={Link}
                  to="/"
                  css={{ '&:not(:hover)': { color: '#58696d !important' } }}
                >
                  JSON-LD Schema Generator
                </Paragraph>
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </div>
        <Link
          href="https://saijogeorge.com"
          css={{
            display: 'none',
            [media.tablet]: { display: 'flex' },
            alignItems: 'center',
            // color: 'rgba(0, 0, 0, 0.85) !important',
            marginLeft: 'auto',
          }}
        >
          <Paragraph>Created by Saijo George</Paragraph>
          <Img
            fluid={data.avatar.childImageSharp.fluid}
            alt=""
            css={{
              width: 30,
              height: 30,
              marginLeft: 15,
              borderRadius: '50%',
              filter: 'grayscale(1)',
              transition: '.3s',
              'a:hover &': {
                transform: 'scale(1.65)',
                filter: 'grayscale(0)',
              },
            }}
          />
        </Link>
      </Container>
    </header>
  )
}

// const Footer = props => (
//   <footer
//     css={{ padding: `${rem(100)} 0`, color: '#fff', backgroundColor: '#000' }}
//     {...props}
//   >
//     <Container css={{ display: 'flex' }}>
//       <Link to="/">Logo</Link>
//       <span css={{ marginLeft: 'auto' }}>© {new Date().getFullYear()}</span>
//     </Container>
//   </footer>
// )

const Layout = ({ title, isRoot, children }) => (
  <>
    <Head />
    <Header title={title} isRoot={isRoot} />
    <main>{children}</main>
  </>
)

export default Layout
